import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders, contentXWWWHeaders } from 'common/headers';
import { packagingUomData } from './packaging/packaging-uom';
import { segmentsData } from '../../product-details/segments-data-stub';


import * as _ from 'lodash';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class ItemDetailService extends BaseHttpService {

    fetchItemDetail(brandId: string, id: number): Observable<any> {
      return this.http.get(Config.API + '/items/' + brandId + '/' + id.toString())

        .pipe(map( (itemDetail) => {

          this.prepareItemDetailPackages(itemDetail);

          /*
            * fix descriptions that are not lists
          */
          _.each(_.filter(segmentsData.descriptions, ['type', 'list']), (item: any) => {
            const desc = _.get(itemDetail, item.item_name);
            _.map(desc, (descLanguage: any, language: any) => {
              if (!_.isArray(descLanguage)) {
                const value = descLanguage;
                descLanguage = [];
                descLanguage.push(value);
                _.set(itemDetail, item.item_name + '.' + language, descLanguage);
              }
            });
          });

          return itemDetail;
        }),
        catchError(this.handleError.bind(this)));
    }

    fetchItemDetailPackages(brandId: string, id: number): Observable<any> {
      return this.http.get(Config.API + '/items/' + brandId + '/' + id.toString() + '/packages')

        .pipe(map( (itemDetail) => {

          this.prepareItemDetailPackages(itemDetail);

          /*
            * fix descriptions that are not lists
          */
          _.each(_.filter(segmentsData.descriptions, ['type', 'list']), (item: any) => {
            const desc = _.get(itemDetail, item.item_name);
            _.map(desc, (descLanguage: any, language: any) => {
              if (!_.isArray(descLanguage)) {
                const value = descLanguage;
                descLanguage = [];
                descLanguage.push(value);
                _.set(itemDetail, item.item_name + '.' + language, descLanguage);
              }
            });
          });

          return itemDetail;
        }),
        catchError(this.handleError.bind(this)));
    }

    prepareItemDetailPackages(itemDetail: any = {}): any {
      /*
       * Map the Package Title to the ItemDetail Packages
       */
        if ( !_.has(itemDetail, 'packages') ) {
          _.set(itemDetail, 'packages', {});
        }

        const packageTypes = _.map(packagingUomData, 'uom');
        /*
         * Loop through the itemDetail's packages and set the title
         */
        _.each(packageTypes, (packageType) => {

          const packageUom: any = _.find(packagingUomData, ['uom', packageType]);
          let packageUomTitle = '';
          let packageUomType = '';

          if (packageUom) {
              packageUomTitle = packageUom.title;
              packageUomType = packageUom.uom;
          }

          if ( !_.has(itemDetail.packages, packageUom.uom) ) {
            _.set(itemDetail.packages, packageUom.uom, {} );
          }
          _.set(itemDetail.packages, packageUom.uom + '.title', packageUomTitle );
          _.set(itemDetail.packages, packageUom.uom + '.packageUom', packageUomType );
        });

        /*
         * fix hazardous material regulated if it is not populated.
         */
        _.each(itemDetail.packages, (itemPackage) => {
            if (
              _.has(itemPackage, 'hazardous_materials.0.regulated') &&
              !_.has(itemPackage, 'hazardous_materials.0.regulated.regulated')
            ) {
              const regulated: string = _.get(itemPackage, 'hazardous_materials.0.is_regulated', '');
              _.set(itemPackage, 'hazardous_materials.0.regulated.regulated', regulated);
            }
        });
        return itemDetail;
    }

    postUpdateStatus(brandId: string, itemId: number, status: number): Observable<any> {
      const body = JSON.stringify({status: status});
      return this.http.post(Config.API + '/items/' + brandId + '/' + itemId + '/status', body, {headers: contentHeaders})

          .pipe(catchError(this.handleError.bind(this)));
    }

    postAcceptImported(brandId: string, itemId: number): Observable<any> {
      const body = JSON.stringify({});
      return this.http.post(Config.API + '/items/' + brandId + '/' + itemId + '/accept-imported', body, {headers: contentHeaders})

          .pipe(catchError(this.handleError.bind(this)));
    }

    putSegmentData(brandId: string, itemId: number, segment: string, data: any): Observable<any> {
      const sessionId = this.sessionService.getSessionId();

      const body = JSON.stringify({sessionId: sessionId, data: data});
      return this.http.put(Config.API + '/items/' + brandId + '/' + itemId + '/' + segment, body, {headers: contentHeaders})

          .pipe(catchError(this.handleError.bind(this)));
    }

    postSegmentDataBulk(
      brandId: string,
      ids: any,
      segment: string,
      data: any,
      filter?: any,
      list?: any
    ): Observable<any> {

      data = JSON.stringify(data);
      ids = JSON.stringify(ids);

      const sessionId = this.sessionService.getSessionId();
      const body = '&data=' + encodeURIComponent(data) + '&ids=' + ids + '&sessionId=' + sessionId + filter;

      return this.http.post(`${Config.API}/items/${brandId}/bulk-update/${segment}`, body, {headers: contentXWWWHeaders})
          .pipe(catchError(this.handleError.bind(this)));
    }

}
